import request from '@/utils/request'

export function taskCancel(params) {
  return request({
    url: '/tasks/taskcancel',
    method: 'get',
    params: params
  })

}

export function updateTaskDetail(data) {
  return request({
    url: '/tasks/updatetasksdetail',
    method: 'post',
    data
  })

}

export function sellerWorkTop(params) {
  return request({
    url: '/tasks/sellerworktop',
    method: 'get',
    params: params
  })
}

export function getScoreImg(params) {
  return request({
    url: '/tasks/getscoreimg',
    method: 'get',
    params: params
  })
}

export function updataTaskReview(params) {
  return request({
    url: '/tasks/updatataskreview',
    method: 'get',
    params: params
  })
}

export function getDetailFile(params) {
  return request({
    url: '/tasks/getdetailfile',
    method: 'get',
    params: params
  })
}
